import router from "@/router"
import store from "@/store"

// 跳转首页
export const goHome = () => {
    router.push('/')
}

// 退出登录
export const logOut = () => {
    localStorage.removeItem('token');
    store.commit('setToken', '');
    goHome()
}

// 检测登录跳转
export const checkoutLogin = (callback) => {
    if (!store.state.token) {
        router.push('/login')
    } else {
        typeof callback === 'function' && callback()
    }
}